export const awsRealTimeTxt = {
  LINK_ACCOUNT: "link account",
  LINKING: "linking",
  AWS_CLOUD_FORMATION_STACK_CREATION: "AWS CloudFormation stack creation",
  REAL_TIME_DATA_BUCKET_NAME_ERROR_TXT: "Provide the bucket that contains CloudTrail event files",
  AWS_CLOUD_SHELL_INSTRUCTIONS_TITLE: "AWS CLI instructions",
  AWS_CLOUD_SHELL_INSTRUCTIONS:
    "You can run the following commands in AWS CloudShell, just open your AWS console and type CloudShell in the search box.",
  AWS_CLOUD_FORMATION_STACK_CREATION_WAITING_TXT:
    "After you create stack on AWS, please wait as this may take up to 30 seconds...",
  AWS_CLI_WAITING_TXT: "After you run the CLI commands, please wait as this may take up to 30 seconds...",
  S3_BUCKET_NAME_LABEL: "S3 bucket name",
  S3_BUCKET_NAME_PLACEHOLDER: "Enter S3 bucket name",
  CANCEL_BTN: "Cancel",
  PREFER_CLI: "Prefer CLI?",
  UPDATE_ACCOUNT: "update account",
  UPDATING: "updating",
  INCLUDE: "Include",
  AVAILABLE_FEATURES: "Available features",
  FEATURE_ALREADY_ENABLED: "Feature already enabled",
};
